<template>
    <jet-form-section @submit="">
        <template #title>
            Username
        </template>

        <template #description>
            Changing username is not allowed at the moment, because it will change your personal teams repository URL.
        </template>

        <template #form>
            <p class="fz-14 mt-4 mb-2">
                Your current username is <span class="text-style">{{ user.username }}</span>
            </p>

        </template>

    </jet-form-section>
</template>

<script>
    import JetFormSection from "@/Jetstream/FormSection";

    export default {
        components: {
            JetFormSection
        },

        props: ['user'],

        data() {
            return {}
        }

    }
</script>

<style scoped>

</style>
